import React from 'react';
import Category from '../../../category/Category';
import { MonTextS14W300LH22, MonTextS24W500LH32LS05Minu1C1C } from '../../../texts/fontText/montserrat/TextMon';
import './content565.scss';
import { ICategory } from '../../../../tpyes/comment';
import { useNavigate } from 'react-router';

interface IMainNews {
  title?: string;
  subtitle?: string;
  category?: ICategory | undefined;
  id?: string;
  noBorder?: boolean;
  
}

const Content565 = ({ title, subtitle, category, id, noBorder }: IMainNews) => {
  const navigate = useNavigate();

  const { name } = category || { name: '' };
  return (
    <div className="content565">
      <div className={`container flex fd-col`}>
        <div className={`${noBorder ? 'no-border' : 'border-bottom-gray'} pb36`}>
          <div className='category-box'>
            <Category value={name} />
          </div>

          <div className="content-box flex fd-row jc-between">
            <div className="text-box flex fd-col">
              <div className="title-box flex ai-center" onClick={() => navigate(`/news/${id}`)}>
                <MonTextS24W500LH32LS05Minu1C1C text={title} />
              </div>
              <div className="detail-box">
                <MonTextS14W300LH22 text={subtitle} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content565;
